import { IconName, IconNames } from '@blueprintjs/icons'

import { i18nKeys } from '../../../app.i18n'
import { ReviewType } from '../../models'

export const ReviewTypeMap: { [key: number]: { title: string; icon: IconName; type: ReviewType } } = {
  [ReviewType.MidYear]: {
    title: i18nKeys.frontFace.reviews.type.midYear,
    icon: IconNames.RING,
    type: ReviewType.MidYear,
  },
  [ReviewType.Probation]: {
    title: i18nKeys.frontFace.reviews.type.probation,
    icon: IconNames.ENDORSED,
    type: ReviewType.Probation,
  },
  [ReviewType.ChangePosition]: {
    title: i18nKeys.frontFace.reviews.type.changePosition,
    icon: IconNames.AIRPLANE,
    type: ReviewType.ChangePosition,
  },
  [ReviewType.EndYear]: {
    title: i18nKeys.frontFace.reviews.type.endYear,
    icon: IconNames.FULL_CIRCLE,
    type: ReviewType.EndYear,
  },
  [ReviewType.OneToOne]: {
    title: i18nKeys.frontFace.reviews.type.oneToOne,
    icon: IconNames.CHAT,
    type: ReviewType.OneToOne,
  },
  [ReviewType.LeaveCompany]: {
    title: i18nKeys.frontFace.reviews.type.leaveCompany,
    icon: IconNames.HEART_BROKEN,
    type: ReviewType.LeaveCompany,
  },
  [ReviewType.Exit]: {
    title: i18nKeys.frontFace.reviews.type.exit,
    icon: IconNames.HEART_BROKEN,
    type: ReviewType.Exit,
  },
  [ReviewType.MidYearNew]: {
    title: i18nKeys.frontFace.reviews.type.midYear,
    icon: IconNames.RING,
    type: ReviewType.MidYearNew,
  },
  [ReviewType.EndYearNew]: {
    title: i18nKeys.frontFace.reviews.type.endYear,
    icon: IconNames.FULL_CIRCLE,
    type: ReviewType.EndYearNew,
  },
}



// WEBPACK FOOTER //
// ./src/app/front-face/shared/review/type-map.ts